import React from 'react'
import styles from './TestResults.module.css'

interface TestingControlsProps {
  testCount: number | ''
  setTestCount: (value: number | '') => void
  hasTestedBefore: boolean
  isTestingPrompt: boolean
  promptText: string
  onTestPrompt: (useNewAudits: boolean) => void
}

function TestingControls({
  testCount,
  setTestCount,
  hasTestedBefore,
  isTestingPrompt,
  promptText,
  onTestPrompt,
}: TestingControlsProps) {
  return (
    <div className={styles.testingControls}>
      <div className={styles.testCountInputWrapper}>
        <label className={styles.testCountLabel}># of Audits to Test:</label>
        <input
          type='text'
          className={styles.testCountInputCompact}
          value={testCount}
          onChange={(e) => {
            const value = e.target.value
            // Allow empty string while typing
            if (value === '') {
              setTestCount('')
              return
            }
            // Only allow numbers
            const num = parseInt(value)
            if (!isNaN(num)) {
              setTestCount(num)
            }
          }}
          onBlur={() => {
            // On blur, ensure we have a valid number
            if (testCount === '' || testCount < 1) {
              setTestCount(5)
            } else if (testCount > 100) {
              setTestCount(100)
            }
          }}
          placeholder='5'
        />
        <span className={styles.testCountHelper}>
          ({testCount || 0} pass + {testCount || 0} fail ={' '}
          {(testCount || 0) * 2} total)
        </span>
      </div>

      {!hasTestedBefore ? (
        <button
          className={styles.testButtonCompact}
          onClick={() => onTestPrompt(true)}
          disabled={
            isTestingPrompt ||
            !promptText ||
            !testCount ||
            testCount < 1 ||
            testCount > 100
          }
        >
          {isTestingPrompt ? 'Testing...' : 'Test Prompt'}
        </button>
      ) : (
        <>
          <button
            className={styles.testButtonCompact}
            onClick={() => onTestPrompt(false)}
            disabled={
              isTestingPrompt ||
              !promptText ||
              !testCount ||
              testCount < 1 ||
              testCount > 100
            }
          >
            {isTestingPrompt ? 'Testing...' : 'Test Against Same Audits'}
          </button>
          <button
            className={styles.testButtonCompact}
            onClick={() => onTestPrompt(true)}
            disabled={
              isTestingPrompt ||
              !promptText ||
              !testCount ||
              testCount < 1 ||
              testCount > 100
            }
            style={{ marginLeft: '8px' }}
          >
            {isTestingPrompt ? 'Testing...' : 'Test Against New Audits'}
          </button>
        </>
      )}
    </div>
  )
}

export default TestingControls
